import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import MeetAssignment from './views/MeetAssignment.vue'
import MeetView from './views/MeetView.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/meet', //new meet
      name: 'MeetAssignment',
      component: MeetAssignment
    },
    {
      path: '/meet/view/:id', //view meet
      name: 'MeetView',
      component: MeetView
    }
  ]
})
